import styled from 'styled-components'

export const StyledH1 = styled.h1`
	font-size: 58px;
	line-height: 68px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	color: #264445;
	@media (max-width: 768px) {
		font-size: 48px;
		line-height: normal;
	}
	@media (max-width: 425px) {
		font-size: 34px;
		text-align: center;
	}
`
